import React from "react";
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, ButtonGroup} from "reactstrap";
import {Parts} from "components/index";
import Select from 'react-select';
import moment from 'moment-timezone';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import IconButton from "@material-ui/core/IconButton";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";
import {Link} from "react-router-dom";

export default class MainCalendar extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Regions._name, API.RequestType.READ_ALL);
		super(props, model);
		this.timeout = null;
		this.state.search = "";
		this.state.filterFilledHoles = false;
		this.state.filterHoles = false;
		this.state.region = 0
		this.state.regions = [];
		this.state.calResources = [];
		this.state.filterAll = false;
		this.state.suspendTimeout = false;
		this.state.loadingResourcesWait = false;
		this.state.lastCalResourcesFilter = null;
		this.state.lastCalResourcesTimeout = null;
		try {
			if (JSON.parse(localStorage.getItem('regions'))) {
				this.state.selectedRegions = JSON.parse(localStorage.getItem('regions')) ?? [];
			} else {
				this.state.selectedRegions = [];
			}
			if (JSON.parse(localStorage.getItem('users')) && !window.location.href.includes('?:')) {
				this.state.selectedUsers = JSON.parse(localStorage.getItem('users')) ?? [];
			} else {
				this.state.selectedUsers = [];
			}
			if (localStorage.getItem('date') && !(this.props.id > 0)) {
				this.state.filterDate = moment(localStorage.getItem('date')).tz('America/Phoenix').format() ?? "";
			} else {
				if (window.location.href.includes('%20')) {
					this.state.filterDate = moment(window.location.href.split('%20')[1]).format()
				}
				this.state.filterDate = moment().tz('America/Phoenix').format();
			}
			if (localStorage.getItem('users') && !window.location.href.includes('?:')) {
				this.state.selectedUsers = JSON.parse(localStorage.getItem('users')) ?? [];
			} else {
				this.state.selectedUsers = [];
			}
			if (localStorage.getItem('regions')) {
				this.state.selectedRegions = JSON.parse(localStorage.getItem('regions')) ?? [];
			} else {
				this.state.selectedRegions = [];
			}
		} catch (e) {
			//TODO: trackJS this error
			console.log(e, 'error')
		}
		this.state.user = 0;
		this.handleSearch = this.handleSearch.bind(this);
		this.handleUsers = this.handleUsers.bind(this);
		this.handleDate = this.handleDate.bind(this);
		this.state.limit = 50;
		this.state.calendarView = window.location.href.includes('%20') ? 'week' : localStorage.getItem('view') ?? 'day';
		localStorage.setItem('ticketToggled', 'no');//this is to guarantee that initial ticket will always pop
		this.state.shouldReloadCalendar = Math.random();
	}

	//initial load
	async componentDidMount() {
		moment.tz.setDefault("America/Phoenix")
		this.getCalRegions().then();
		await this.loadPkeyData().then();
		// Resources can shrink a persisted user filter before the tickets snapshot. Take tickets after that settles.
		await this.getCalResources();
		await this.getCalTickets();
		this.refreshDataTimeout = setInterval(() => {
			this.pollCalendarData();
		}, 30000)
	}

	componentWillUnmount() {
		this.unmounted = true;
		this.clearRefreshTimer();
		this.cancelCalendarRequest(this.resourcesAjax);
		this.cancelCalendarRequest(this.ticketsAjax);
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.filterEngineer !== this.props.filterEngineer) {
			//once initial load we filter it down to one engineer, if they select a different one and back out it shows all like the normal calendar
			this.handleUsers([{value: this.props.filterEngineer}])
		}
		if (this.props.shouldCalendarReload !== prevProps.shouldCalendarReload) {
			this.getCalTickets().then(() => {
				this.reloadTable()
			})
		}
	}

	loadPkeyData = async (ticket = null) => {
		let pkey = ticket ? ticket : (this.props.id !== "" && this.props.id > 0 && this.props.id !== " " && this.props.id !== undefined) ? this.props.id : null;
		if (pkey) {
			let pkeyModel = new API.BuildClass(Types.Tickets._name, API.RequestType.READ);
			pkeyModel.object.pkey = pkey;
			let functioning = await pkeyModel.submit(null, 'GET');
			let momentDate = moment(functioning.appointment_start).format();
			let region = this.state.regions.filter((item) => item.pkey === functioning.field_engineers.region)
			this.state.selectedRegions = ([{value: region[0].pkey, label: region[0].name}]);
			this.state.selectedUsers = [];
			localStorage.setItem('users', JSON.stringify([]));
			localStorage.setItem('regions', JSON.stringify(this.state.selectedRegions));
			localStorage.setItem('date', momentDate)
			this.state.ticket = functioning;
			this.state.filterDate = momentDate;
			if (ticket) {
				// Resources narrows selectedUsers. Tickets must snapshot that filter, or the stale-response guard drops the week.
				await this.getCalResources();
				await this.getCalTickets();
				this.setState({shouldReloadCalendar: Math.random()});
			}
		}
	}

	handleUpdateData = () => {
		return Promise.all([this.getCalResources(true), this.getCalTickets()]);
	}

	pollCalendarData = () => {
		// Resources and tickets start together. A newer poll or day change
		// aborts the previous request of that same kind.
		this.getCalResources(true);
		this.getCalTickets();
	}


	isAbortError(error) {
		if (!error) {
			return false;
		}
		if (error.aborted || error.statusText === 'abort') {
			return true;
		}
		return String(error.message || error).toLowerCase() === 'abort';
	}

	cancelCalendarRequest(ajax) {
		if (ajax && typeof ajax.cancel === 'function') {
			ajax.cancel();
		}
	}

	// submit() cannot abort. submitCancelable can. Patch $.ajax only for the
	// synchronous start so a dropped day-change does not keep the browser waiting.
	replaceRequest(slot, model, read) {
		this.cancelCalendarRequest(this[slot]);
		const ajax = {};
		let captured = null;
		const originalAjax = $.ajax;
		$.ajax = function () {
			const xhr = originalAjax.apply(this, arguments);
			captured = xhr;
			return xhr;
		};
		let promise;
		try {
			promise = new Promise((resolve, reject) => {
				model.submitCancelable(ajax, read, (response) => resolve(response));
				if (captured && typeof captured.fail === 'function') {
					captured.fail((_xhr, textStatus) => {
						if (textStatus === 'abort') {
							reject({aborted: true});
						} else {
							reject(_xhr);
						}
					});
				}
			});
		} finally {
			$.ajax = originalAjax;
		}
		this[slot] = ajax;
		return promise;
	}

	calendarTicketFilter = () => ({
		filterHoles: this.state.filterHoles,
		filterFilledHoles: this.state.filterFilledHoles,
		filterDate: moment(this.state.filterDate).tz('America/Phoenix').format(),
		filterRegions: this.state.selectedRegions.map((region) => region.value),
		filterUsers: this.state.filterHoles ? [] : this.state.selectedUsers.map((user) => user.value),
	})

	weekStartYmd(date) {
		const phoenix = moment(date).tz('America/Phoenix');
		const basis = phoenix.isValid() ? phoenix : moment().tz('America/Phoenix');
		return basis.clone().startOf('day').subtract(basis.day(), 'days').format('YYYY-MM-DD');
	}

	// The API returns the Sunday-Saturday week around filterDate. A response is
	// still current when only the day inside that week has moved.
	calendarTicketScopeKey = () => {
		const filter = this.calendarTicketFilter();
		filter.filterDate = this.weekStartYmd(this.state.filterDate);
		return JSON.stringify(filter);
	}

	getCalTickets = async (scopeRetry = false) => {
		let model = new API.BuildClass(Types.Calendar._name, API.RequestType.READ);
		this.read = 'GET_ALL';
		model.limit = 5000;
		const requestSeq = (this.calTicketsRequestSeq || 0) + 1;
		const scopeKey = this.calendarTicketScopeKey();
		this.calTicketsRequestSeq = requestSeq;
		this.calTicketsFilterKey = scopeKey;
		try {
			model.filter = this.calendarTicketFilter();
			//model.search = this.state.search
			const read = this.read;
			const calEventResponse = await this.replaceRequest('ticketsAjax', model, read);
			if (this.unmounted || this.calTicketsRequestSeq !== requestSeq) {
				return this.state.calEvent;
			}
			// Resources can narrow selectedUsers while this request is in flight. Re-fetch once with the filter that is current now.
			if (this.calendarTicketScopeKey() !== scopeKey) {
				if (!scopeRetry) {
					return this.getCalTickets(true);
				}
				return this.state.calEvent;
			}
			if (!calEventResponse || !Array.isArray(calEventResponse.items)) {
				return this.state.calEvent;
			}
			this.mapsUrls = calEventResponse.mapsUrls ?? [];
			this.state.startDate = calEventResponse.start_date;
			this.rawCalEvents = calEventResponse.items;
			this.publishCalendar();
			return this.state.calEvent;
		} catch (error) {
			if (!this.isAbortError(error)) {
				console.log(error, 'error');
				// Let the next day change retry this week instead of waiting for the poll.
				if (this.calTicketsRequestSeq === requestSeq) {
					this.calTicketsFilterKey = null;
				}
			}
		}
		return this.state.calEvent;
	}

	publishCalendar() {
		if (this.unmounted || !Array.isArray(this.rawCalEvents)) {
			return;
		}
		const resourceRows = Array.isArray(this.calResources)
			? this.calResources
			: (Array.isArray(this.state.calResources) ? this.state.calResources : []);
		const events = this.buildCalendarEvents(this.rawCalEvents.slice(), resourceRows, this.state.startDate);
		this.calEvent = events;
		this.setState({
			calEvent: events,
			mapsUrls: this.mapsUrls || []
		});
	}

	buildCalendarEvents(items, resourceRows, startDate) {
		const _calEvent = items;
		resourceRows.forEach((user) => {
				if (user.onboarding_date) {
					for (let i = 0; i <= 7; i++) {
						const date = moment(startDate).add(i, 'days');
						if (!date.isSameOrBefore(user.onboarding_date, 'day')) {
							continue;
						}
						if (date.isSame(user.onboarding_date, 'day')) {
							//add first day in field header only
							_calEvent.push({
								allDay: true,
								all_regions: null,
								color: "#308070",
								created: Date.now(),
								creator: null,
								description: null,
								end: moment(startDate).add(i, 'days').add(6, "hours").format(),
								resourceId: user.resourceId,
								modified: null,
								modifier: null,
								pkey: null,
								start: moment(startDate).add(i, 'days').add(6, "hours").format(),
								ticket: null,
								title: "First Day in Field",
								users: user,
								auto_gen: true
							})
						} else {
							_calEvent.push({
								allDay: true,
								all_regions: null,
								color: "#308070",
								created: Date.now(),
								creator: null,
								description: null,
								end: moment(startDate).add(i, 'days').add(6, "hours").format(),
								resourceId: user.resourceId,
								modified: null,
								modifier: null,
								pkey: null,
								start: moment(startDate).add(i, 'days').add(6, "hours").format(),
								ticket: null,
								title: "Onboarding (Auto-Gen)",
								users: user,
								auto_gen: true
							}, {
								allDay: false,
								all_regions: null,
								color: "#308070",
								created: Date.now(),
								creator: null,
								description: null,
								end: moment(startDate + " " + "19:00:00").add(i, 'days').format(),
								resourceId: user.resourceId,
								modified: null,
								modifier: null,
								pkey: null,
								start: moment(startDate + " " + "08:00:00").add(i, 'days').format(),
								ticket: null,
								title: `DO NOT BOOK - ONBOARDING (Auto-Gen) First day running WOs in the field is ${moment(user.onboarding_date).format('dddd M/D')}`,
								users: user,
								auto_gen: true
							})
						}
					}
				}
				if (user.last_day_working) {
					const lastDay = moment(user.last_day_working);
					for (let i = 0; i <= 7; i++) {
						const date = moment(startDate).add(i, 'days');
						if (date.isBefore(lastDay, 'day')) {
							continue;
						}
						if (date.isSame(lastDay, 'day')) {
							// Skip if API already persisted a last-day notice header for this day
							const hasPersistedNotice = _calEvent.some((e) =>
								e.resourceId === user.resourceId
								&& e.allDay
								&& e.title
								&& String(e.title).includes('Last Day Working')
								&& moment(e.start).isSame(date, 'day')
							);
							if (!hasPersistedNotice) {
								_calEvent.push({
									allDay: true,
									all_regions: null,
									color: "#EB6E23",
									created: Date.now(),
									creator: null,
									description: null,
									end: moment(startDate).add(i, 'days').add(6, "hours").format(),
									resourceId: user.resourceId,
									modified: null,
									modifier: null,
									pkey: null,
									start: moment(startDate).add(i, 'days').add(6, "hours").format(),
									ticket: null,
									title: "Last Day Working",
									users: user,
									auto_gen: true
								})
							}
						} else {
							_calEvent.push({
								allDay: true,
								all_regions: null,
								color: "#EB6E23",
								created: Date.now(),
								creator: null,
								description: null,
								end: moment(startDate).add(i, 'days').add(6, "hours").format(),
								resourceId: user.resourceId,
								modified: null,
								modifier: null,
								pkey: null,
								start: moment(startDate).add(i, 'days').add(6, "hours").format(),
								ticket: null,
								title: "Last Day (Auto-Gen)",
								users: user,
								auto_gen: true
							}, {
								allDay: false,
								all_regions: null,
								color: "#EB6E23",
								created: Date.now(),
								creator: null,
								description: null,
								end: moment(startDate + " " + "19:00:00").add(i, 'days').format(),
								resourceId: user.resourceId,
								modified: null,
								modifier: null,
								pkey: null,
								start: moment(startDate + " " + "08:00:00").add(i, 'days').format(),
								ticket: null,
								title: `DO NOT BOOK - LAST DAY (Auto-Gen) Last day working was ${lastDay.format('dddd M/D')}`,
								users: user,
								auto_gen: true
							})
						}
					}
				}
				if (user.workingDays) {
					let _workingDays = user.workingDays.split(",");
					_workingDays = _workingDays.map((day) => {
						const date = moment().day(day);
						return date.day();
					})
					_workingDays.forEach((day) => {
						_calEvent.push({
							allDay: true,
							all_regions: null,
							color: "",
							created: Date.now(),
							creator: null,
							description: null,
							end: moment(startDate).add(day, 'days').add(6, "hours").format(),
							resourceId: user.resourceId,
							modified: null,
							modifier: null,
							pkey: null,
							start: moment(startDate).add(day, 'days').add(6, "hours").format(),
							ticket: null,
							title: "Scheduled Off (Auto-Gen)",
							users: user,
							auto_gen: true
						}, {
							allDay: false,
							all_regions: null,
							color: "#ffc107",
							created: Date.now(),
							creator: null,
							description: null,
							end: moment(startDate + " " + "19:00:00").add(day, 'days').format(),
							resourceId: user.resourceId,
							modified: null,
							modifier: null,
							pkey: null,
							start: moment(startDate + " " + "08:00:00").add(day, 'days').format(),
							ticket: null,
							title: "DO NOT BOOK (Auto-Gen)",
							users: user,
							auto_gen: true
						})
					})
				}
				if (parseInt(user.fe_work_order_amount) > 0 && parseInt(user.fe_work_order_amount) !== 4 && user.active) {
					for (let i = 0; i <= 6; i++) {
						_calEvent.push({
							allDay: true,
							all_regions: null,
							color: "",
							created: Date.now(),
							creator: null,
							description: null,
							end: moment(startDate).add(i, 'days').add(6, "hours").format(),
							resourceId: user.resourceId,
							modified: null,
							modifier: null,
							pkey: null,
							start: moment(startDate).add(i, 'days').add(6, "hours").format(),
							ticket: null,
							title: `${user.fe_work_order_amount.toString()} Billables (Auto-Gen)`,
							users: user,
							auto_gen: true
						})
					}
				}
			});
		return _calEvent;
	}

	getCalRegions = async () => {
		let model = new API.BuildClass(Types.Regions._name, API.RequestType.READ_ALL);
		this.read = 'GET_ALL';
		model.limit = 5000;
		try {
			this.regions = await model.submit(null, this.read);
			this.regions = Object.keys(this.regions).map((key) => this.regions[key]);
			this.regions = this.regions[3];
			this.regions = this.regions.sort(function (a, b) {
				return a.name.localeCompare(b.name)
			})
			this.setState({
				regions: this.regions
			});
		} catch (error) {
		}
		return this.state.regions;
	}


	getCalResources = async (forceRefresh = false) => {
		let model = new API.BuildClass(Types.Calendar_Resources._name, API.RequestType.READ);
		this.read = 'GET_ALL';
		if (this.props.old) {
			model = new API.BuildClass(Types.Users._name, API.RequestType.READ);
			this.read = 'GET_CALENDAR_RESOURCES';
		}
		model.limit = 5000;
		let usersPkeys = window.location.href.includes("?:") ? [parseInt(window.location.href.split('?:')[1])] : this.state.ticket && localStorage.getItem('ticketToggled') === 'no' ? [this.state.ticket.field_engineer] : this.state.selectedUsers.map((user) => user.value)
		const resourcesFilterKey = this.currentResourcesFilterKey();
		const resourceFilter = JSON.parse(resourcesFilterKey);

		if (forceRefresh || this.state.lastCalResourcesFilter !== resourcesFilterKey) {
			const requestSeq = (this.calResourcesRequestSeq || 0) + 1;
			this.calResourcesRequestSeq = requestSeq;
			try {
				model.filter = resourceFilter;
				const read = this.read;
				const response = await this.replaceRequest('resourcesAjax', model, read);
				if (this.unmounted || this.calResourcesRequestSeq !== requestSeq || this.currentResourcesFilterKey() !== resourcesFilterKey) {
					return Array.isArray(this.state.calResources) ? this.state.calResources : [];
				}
				// Only a successful response owns this filter. A failure must stay
				// retryable on the next poll instead of looking already loaded.
				this.state.lastCalResourcesFilter = resourcesFilterKey;

				if (this.state.filterHoles && !response?.holesPkeys) {
					this.setState({noHoles: true});
				} else {
					this.setState({noHoles: false});
				}
				const resources = Array.isArray(response?.items) ? response.items : [];
				this.calResources = resources;
				let selected = resources.filter(item => usersPkeys.includes(item.resourceId));
				if (selected.length !== 0) {
					this.state.selectedUsers = resources.filter(item => usersPkeys.includes(item.resourceId)).map((user) => {
						return {value: user.resourceId, label: user.resourceTitle}
					});
				}
				this.state.calResources = resources;
				this.state.key = Math.random();
				this.setState({
					calResources: resources,
					key: this.state.key,
				});
				// Scheduled Off and the other auto-gen blocks come from these rows.
				// Tickets often return first and would otherwise keep the previous
				// week's generated events until the next poll.
				this.publishCalendar();

			} catch (error) {
				if (!this.isAbortError(error)) {
					console.log(error, 'error');
				}
			}
		}
		return this.state.calResources;
	}

	currentResourcesFilterKey() {
		let week = moment(this.state.filterDate).add(1, 'day').isoWeek().toString();
		let prevweek = moment(this.state.filterDate).isoWeek().toString();
		if (week.length === 1) {
			week = ('0' + week);
		}
		if (prevweek.length === 1) {
			prevweek = ('0' + prevweek);
		}
		const year = moment(this.state.filterDate).year().toString();
		return JSON.stringify({
			'filterRegions': this.state.selectedRegions.map((region) => region.value),
			'filterDate': year + week,
			'prevDate': year + prevweek,
			'date': moment(this.state.filterDate).tz('America/Phoenix').format('YYYY-MM-DD'),
			'filterHoles': this.state.filterHoles
		});
	}

	suspendTimeout = () => {
		this.clearRefreshTimer();
	}

	enableTimeout = () => {
		// Re-arming without clearing would stack a second 30 s poller.
		this.clearRefreshTimer();
		this.refreshDataTimeout = setInterval(() => {
			this.pollCalendarData();
		}, 30000)
	}

	handleSearch = async (inputValue) => {
		let customerModel = new API.BuildClass(Types.Calendar._name, API.RequestType.READ);
		this.read = 'GET_SEARCHING';

		customerModel.search = inputValue
		customerModel.source = 'testing';
		return await customerModel.submit(null, this.read);

	}

	//These functions below are overriding the base collection functions so that we can better use the autosuggestion and searching functionality
	handleInputChange = (evt, {newValue}) => {
		this.doSearch(evt, newValue);
	}

	doSearch = (event, newValue) => {
		let searchText = typeof newValue !== 'undefined' ? newValue : event.target.value;
		searchText = searchText || '';
		this.setState({search: searchText !== "=undefined:" ? searchText : ""});
	};

	getSuggestions = async value => {
		const inputValue = value.trim().toLowerCase();

		if (inputValue.length !== 0) {
			await this.handleSearch(inputValue).then((data) => {
				if (data.items.length !== 0) {
					this.setState({suggestions: data.items})
				} else {
					this.setState({suggestions: [{'start': "No Results Found"}]})
				}
			});
		}
	};

	onSuggestionsFetchRequested = ({value}) => {
		if (this.timeout) {
			clearTimeout(this.timeout)
		}
		this.timeout = setTimeout(async () => {
			await this.getSuggestions(value);
		}, 500)
	};

	renderSuggestion = (suggestion, {isHighlighted}) => {
		if (suggestion.start !== "No Results Found") {
			let startTime = moment(suggestion.start).format("LT")
			let endTime = moment(suggestion.end).format("LT")
			if ((startTime.includes('AM') && endTime.includes('AM')) || (startTime.includes('PM') && endTime.includes('PM'))) {
				startTime = startTime.slice(0, -3);
			}
			startTime = suggestion.fe_start ? suggestion.fe_start.replace(':00', '') : startTime.replace(':00', '');
			endTime = suggestion.fe_end ? suggestion.fe_end.replace(':00', '') : endTime.replace(':00', '');
			//if all day events
			//Need to also probably just see if the dates are a day apart and then dont show time
			let displayTime = (startTime === '12' && endTime === '12 AM') || suggestion.all_day === true ? null : (startTime + '-' + endTime)
			let color = suggestion.color ?? '#2196f3';
			return (
				<div
					style={{
						padding: '4px 6px',
						backgroundColor: isHighlighted ? '#4859b3' : null,
						color: isHighlighted ? 'white' : 'black'
					}}
					onClick={async () => {
						localStorage.setItem('ticketToggled', 'no');
						localStorage.setItem("users", JSON.stringify([]));
						localStorage.setItem("regions", JSON.stringify([]));
						this.state.selectedUsers = [];
						this.state.selectedRegions = [];
						await this.loadPkeyData(suggestion.tickets.pkey ?? null)
						this.setState({search: ""})
					}}
				>

					{moment(suggestion.start).format('D MMM YYYY, ddd')}
					<FiberManualRecordIcon style={{color: `${color}`}}/>
					{displayTime}
					&nbsp;
					&nbsp;
					&nbsp;
					{suggestion.tickets.ticket_customer}
					&nbsp;
					{suggestion.tickets.ticket_location}
				</div>
			);
		} else {
			return <div style={{
				padding: '4px 6px',
			}}>
				No Results Found
			</div>
		}
	};

	// getSuggestionValue = suggestion => {
	// 	this.handleCustomerLoad(suggestion);
	// 	//if we need to fill out the search bar after someone has selected a customer, that goes here
	// };

	handleUsers(value) {
		this.state.selectedChanged = true;
		let users = [];
		if (value) {
			for (let i = 0; i < value.length; i++) {
				users.splice(0, 0, value[i]);
			}
			localStorage.setItem("users", JSON.stringify(value));
			this.state.selectedUsers = users;
		} else {
			localStorage.setItem("users", JSON.stringify([]));
			this.state.selectedUsers = [];
		}
		//refreshing the data after passing filters
		this.getCalResources().then();
		this.getCalTickets().then();
		this.setState({selectedChanged: true})
	}

	handleDate = async (date) => {
		const filterDate = moment(date).tz('America/Phoenix').format();
		const navSeq = (this.dateNavSeq || 0) + 1;
		this.dateNavSeq = navSeq;
		// Set before the first await so a same-tick ticket fetch sees this day.
		this.state.filterDate = filterDate;
		localStorage.setItem("date", filterDate);
		this.setState({loadingResourcesWait: true, filterDate, dateChanged: true});

		//Log that we're day walking (avg call time is less than 50ms, so this seems fine)
		let modelDayWalking = new API.BuildClass(Types.Dispatch._name, API.RequestType.CREATE);
		modelDayWalking.submit(null, 'PUT_DAY_WALKING', true);

		if (this.timeoutRef) {
			clearTimeout(this.timeoutRef);
		}

		// Tickets cover the whole week, so only a week change needs a new request.
		// Resources are per day and reload below.
		if (this.calendarTicketScopeKey() !== this.calTicketsFilterKey) {
			this.getCalTickets();
		}

		await this.getCalResources();
		if (this.unmounted || this.dateNavSeq !== navSeq) {
			return;
		}
		const resources = Array.isArray(this.calResources)
			? this.calResources
			: (Array.isArray(this.state.calResources) ? this.state.calResources : []);
		this.setState({loadingResourcesWait: false, calResources: resources});
	}

	updateSchedule = (updatedInfo) => {
		if (typeof this.props.updateSchedule === 'function') {

			this.props.updateSchedule(updatedInfo);
		}
	}
	handleUpdateView = (view) => {
		this.clearRefreshTimer();
		this.refreshDataTimeout = setInterval(() => {
			this.pollCalendarData();
		}, 30000)
		localStorage.setItem("view", view);
		this.state.calendarView = view;
	}

	clearRefreshTimer = () => {
		if (!this.refreshDataTimeout) {
			return;
		}
		clearInterval(this.refreshDataTimeout);
		clearTimeout(this.refreshDataTimeout);
		this.refreshDataTimeout = null;
	}

	render() {
		const {loading} = this.state;
		const calResources = Array.isArray(this.state.calResources) ? this.state.calResources : [];

		return (
			<div className={"box-body"}>
				<div className={"table-bar"}>
					<div className={"row"}>
						<div className={"col-xs"}>
							{this.renderSearch('Customers', "")}
						</div>
						<div className={'col-4'}>
							<Parts.RegionSelectToggle
								parent={this}
								handleRegionsCallback={() => Promise.all([this.getCalResources(), this.getCalTickets()])}
								multi={true}
								noCycle={false}
							/>
						</div>
						<div className={"col-3"}>
							<Select
								key={calResources}
								placeholder={"User Select"}
								isMulti
								isClearable
								value={this.state.selectedUsers.map(user => {
									return (
										{value: user.value, label: user.label})
								})}
								onChange={this.handleUsers}
								options={calResources.map(user => {
									return (
										{value: user.resourceId, label: user.resourceTitle})
								})}
							/>
						</div>
						<div className={"col-xs"}>
							<ButtonGroup size={"md"}>
								<Button
									id={"all"}
									onClick={() => {
										this.setState({filterHoles: false}, () => {
											Promise.all([this.getCalResources(), this.getCalTickets()]);
										})
									}}
									outline={this.state.filterHoles === true}
									active={this.state.filterHoles === false}
								>
									All
								</Button>
								<Button
									id={'holes'}
									onClick={() => {
										this.setState({filterHoles: true}, () => {
											Promise.all([this.getCalResources(), this.getCalTickets()]);
										})
									}}
									outline={this.state.filterHoles === false}
									active={this.state.filterHoles === true}
									color={'primary'}
								>
									Holes
								</Button>
							</ButtonGroup>
						</div>
						<div className={"col-xs"}>
							<Link to={() => {
								let date = this.state.calendarView === 'week' ? moment(this.state.filterDate).day('Monday').format().split('T')[0] : moment(this.state.filterDate).format().split('T')[0]
								let region = this.state.selectedRegions.length === 0 ? 5 : this.state.selectedRegions[0].value;
								return `/dispatch/mapped?date=${date}&region=${region}`
							}}>
								<Button size={'md'} color={'primary'}>Optimize Routes</Button>
							</Link>
						</div>
						{/*<div className={'col-xs'}>*/}
						{/*	{this.state.noHoles && <h5 style={{display: 'flex', justifySelf: 'center', justifyContent: 'center'}}>There are no holes for this day.</h5>}*/}
						{/*</div>*/}
					</div>
				</div>
				{this.state.calEvent && <Parts.TicketCalendar
					key={this.state.calEvent?.length + this.state.selectedUsers + this.state.selectedRegions + this.state.shouldReloadCalendar + calResources}
					parentProps={this.props}
					ticket={this.state.ticket}
					events={this.state.calEvent}
					//show selectedUsers if any, else load all of them
					resourceMap={this.state.selectedUsers.length > 0 ? calResources.filter((resource) => this.state.selectedUsers.map((user) => user.value).includes(resource.resourceId)) : calResources}
					//lowercase default: Calendar.Views ('month'|'week'|'work_week'|'day'|'agenda')
					defaultView={this.state.calendarView}
					defaultDate={window.location.href.includes('%20') ? moment(window.location.href.split('%20')[1]).format() : this.props.id > 0 || this.state.ticket ? moment(this.state.filterDate).format() : localStorage.getItem('date') ?? moment().tz('America/Phoenix').format()}
					handleUpdateView={this.handleUpdateView}
					//dont pass views anymore, cause we pass a custom toolbar
					reloadSelf={this.state.refresh}
					updateData={this.handleUpdateData}
					handleDate={this.handleDate}
					history={this.props.history}
					mapsUrls={this.state.mapsUrls ? this.state.mapsUrls : []}
					suspendTimeout={this.suspendTimeout}
					enableTimeout={this.enableTimeout}
					noHoles={this.state.noHoles}
					loadingResources={this.state.loadingResourcesWait}
					//resetMapsUrls={this.resetMapsUrls}
				/>}
				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}
